import React, { useEffect } from 'react';
import { Control } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useUserPreferences } from '@/contexts/UserPreferencesContext';
import { SUPPORTED_CURRENCIES } from '@/api/currency';

type CurrencySelectorProps = {
  control: Control<any>;
  name?: string; // Allow custom field name
};

const CurrencySelector: React.FC<CurrencySelectorProps> = ({ control, name = "original_currency" }) => {
  const { preferences } = useUserPreferences();
  
  // Helper function to get display label for currency
  const getCurrencyLabel = (value: string) => {
    const currency = SUPPORTED_CURRENCIES.find(c => c.value === value);
    return currency ? `${currency.label} (${currency.symbol})` : value;
  };

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        // Update field value with user preference when component mounts if no value is set
        useEffect(() => {
          if (preferences?.base_currency) {
            field.onChange(preferences.base_currency);
          }
        }, [preferences]);

        return (
          <FormItem>
            <FormLabel className="text-sm text-muted-foreground mb-1">Para Birimi</FormLabel>
            <FormControl>
              <Select
                value={field.value}
                onValueChange={field.onChange}
                defaultValue={preferences?.base_currency || "TRY"}
              >
                <SelectTrigger className="bg-background">
                  <SelectValue placeholder="Para Birimi Seçin" />
                </SelectTrigger>
                <SelectContent>
                  {SUPPORTED_CURRENCIES.map((currency) => (
                    <SelectItem key={currency.value} value={currency.value}>
                      {currency.label} ({currency.symbol})
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};

export default CurrencySelector; 